import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ProgramItem } from "core/http/service/internalEvents/types";
import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  data?: ProgramItem;
}

const initialState: InitialState = { status: ReduxStateType.INIT, data: {} };

const getDetailProgramSlice = createSlice({
  name: "getDetailProgram",
  initialState,
  reducers: {
    getDetailProgramStart: (
      state,
      action: PayloadAction<{ programId: string }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    getDetailProgramSuccess: (
      state,
      action: PayloadAction<{
        data: ProgramItem;
      }>
    ) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload.data;
    },
    getDetailProgramFailed: (state) => {
      state.status = ReduxStateType.ERROR;
      state.data = {};
    },
    resetDetailProgram: () => initialState,
  },
});

export const {
  getDetailProgramStart,
  getDetailProgramSuccess,
  getDetailProgramFailed,
  resetDetailProgram,
} = getDetailProgramSlice.actions;

export default getDetailProgramSlice.reducer;
